// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/chart.type';
import { SIZE_FULL } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const videoViewsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.video_views_history',
    tooltip: 'chart.pinterest.tooltip_video_views_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.video_views_history_name',
        avg: 'chart.pinterest.video_views_history_avg'
    },
    id: 'video_views_history',
    color: {
        value: 'purple',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.pinterest.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_FULL,
    type: 'chart',
    element: LineChart
};
